export interface ITableSort {
  active: string;
  direction: string;
}

export interface IPage {
  pageNumber: number;
  pageSize: number;
}

export declare type Page = IPage;

export interface IPageInfo {
  page: Page;
  totalCount: number;
}

export interface IResultWithPageInfo<TModel> {
  entities: TModel[];
  pageInfo: IPageInfo;
}

export interface IEntityInfo {
  modelName: string;
  pluralName?: string;
  uriName?: string;
}

export interface IOrderResult {
  orderNbr: number;
  url: string;
}
